import React, { useState, useEffect } from "react";
import axios from "axios"; // Import axios
import { saveAs } from 'file-saver';
function AgreementView({
  setagreementview,
  selectpdf,
  agreementview,
  isDocument,
}) {
  const [presignedUrls, setPresignedUrls] = useState([]);


  let approveDocument = false;

  isDocument === true ? (approveDocument = true) : (approveDocument = false);



  const generatePresignedUrl = async (fileName) => {
    try {
      if (!fileName) {
        console.error("File name is required");
        return null;
      }

      const res = await fetch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/presigned-url`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            key: `${fileName}`,
          }),
        }
      );

      const data = await res.json();

      if (!data?.success || !data?.url) {
        throw new Error("Failed to get pre-signed URL");
      }

      return data.url;

    } catch (error) {
      console.error("Error generating pre-signed URL:", error);
      return null;
    }
  };

  useEffect(() => {
    if (selectpdf) {
      const pdfKeys = isDocument
        ? selectpdf.customerDocuments?.map((doc) => doc) || []
        : [selectpdf.pdfLink];
      if (pdfKeys.length) {
        getPresignedUrls(pdfKeys);
      }
    }
  }, [selectpdf, isDocument]);

  const getPresignedUrls = async (pdfKeys) => {
    console.log(pdfKeys, "check")
    try {
      const urls = await Promise.all(
        pdfKeys.map(async (pdfKey) => {
          let file = pdfKey.split(".com/")[1];
          return await generatePresignedUrl(file)
        })
      );
      setPresignedUrls(urls);
    } catch (error) {
      console.error("Error generating pre-signed URL:", error);
    }
  };
  const ApprovalHandler = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/generatePI/signPhysicalAgreement`,
        {
          status: true,
          document: approveDocument,
          preOrderId: selectpdf._id.toString(),
        }
      );

      // console.log(response.data);
      alert(response.data.message);
    } catch (error) {
      console.error("Error in ApprovalHandler:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setagreementview(false);
    }
  };
  const RejectHandler = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/generatePI/signPhysicalAgreement`,
        {
          status: false,
          document: approveDocument,
          preOrderId: selectpdf._id.toString(),
        }
      );

      // console.log(response.data);
      alert(response.data.message);
    } catch (error) {
      console.error("Error in ApprovalHandler:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setagreementview(false);
    }
  };

  const handleCloseModal = () => {
    setagreementview(false);
  };


  function isIOS() {
    return /iP(hone|od|ad)/.test(navigator.userAgent);
  }

  async function smartDownload(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Fetch failed");

      const blob = await response.blob();
      const contentType = response.headers.get("Content-Type");

      let extension = "";
      if (contentType.includes("pdf")) extension = ".pdf";
      else if (contentType.includes("jpeg")) extension = ".jpg";
      else if (contentType.includes("png")) extension = ".png";
      else extension = ".bin";

      const filename = `downloaded_file${extension}`;

      if (isIOS()) {
        // iOS workaround: open file in new tab instead of saving
        const fileURL = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.target = "_blank"; // open in new tab
        link.click();
        URL.revokeObjectURL(fileURL);
      } else {
        // Other platforms
        saveAs(blob, filename);
      }

    } catch (err) {
      console.error("Download failed:", err);
      alert("File download failed. Please check the URL or network.");
    }
  }
  // Function to handle downloading all files sequentially
  const downloadAllFiles = async () => {
    for (let i = 0; i < presignedUrls.length; i++) {
      await smartDownload(presignedUrls[i]);

      // Small delay between downloads
      if (i < presignedUrls.length - 1) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }
  };

  return (
    <>
      {agreementview && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6 relative">
            <h2 className="text-xl font-bold mb-4">
              {isDocument ? "Document Preview" : "Agreement Preview"}
            </h2>
            <div className="border p-2 h-96 overflow-auto">
              <button
                onClick={handleCloseModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
              >
                &times;
              </button>
              {presignedUrls.length > 0 ? (
                presignedUrls.map((url, index) => (
                  <iframe
                    key={index}
                    src={url}
                    title={`Agreement PDF ${index + 1}`}
                    className="w-full h-full mb-2"
                  />
                ))
              ) : (
                <p>Loading PDFs...</p>
              )}
            </div>

            <div className="flex justify-between mt-4">
              {isDocument && presignedUrls.length > 0 && (
                <button
                  onClick={downloadAllFiles}
                  className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
                    />
                  </svg>
                  Download
                </button>
              )}

              {((isDocument && !selectpdf.isDocumentApprove) ||
                (!isDocument && !selectpdf.isAgreementSigned)) && (
                  <>
                    <button
                      className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600"
                      onClick={ApprovalHandler}
                    >
                      Approve
                    </button>
                    <button
                      className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
                      onClick={RejectHandler}
                    >
                      Reject
                    </button>
                  </>
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AgreementView;
